import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { offerLoaded } from './actions';
import { offerSelected } from 'components/CustomizeOffer/actions';
import { GET_OFFER } from './constants';
import { makeSelectOfferCode, makeSelectChildOfferCode } from './selectors';
import { makeSelectCheckResponse, makeSelectCheckInputData } from 'components/PrescoringTool/selectors';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';
import queryString from 'query-string';

function* fetchOffer() {
  const code = yield select(makeSelectOfferCode());
  const childOffer = yield select(makeSelectChildOfferCode());
  let inputData = yield select(makeSelectCheckInputData());
  let prescoringResponse = yield select(makeSelectCheckResponse());
  inputData = inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData;
  prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;

  const qs = queryString.stringify(prescoringResponse);
  const answers = Object.keys(inputData.answers).map(key => key + '=' + inputData.answers[key]).join(',');

  const requestURL = `${API_URL}offers/${code}?${qs}&contractualCategory=${inputData.contractualCategory}&answers=${answers}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };
    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    const offer = {
      ref: request.data.ref,
      distance: request.data.distance,
      duration: request.data.duration,
      deposit: request.data.deposit,
      bundle: request.data.bundle,
      monthly_rate: request.data.monthly_rate,
      tag: request.data.tag,
      secondaryTag: request.data.secondaryTag,
    };

    if (request.data.hasOwnProperty('child') && Object.keys(childOffer).length > 0) {
      const selected = searchChild(request.data.child.data, childOffer);

      if (selected !== undefined) {
        yield put(offerSelected({...selected, tag: request.data.tag, secondaryTag: request.data.secondaryTag}));
      } else {
        yield put(offerSelected(offer));
      }
    } else {
      yield put(offerSelected(offer));
    }

    yield put(offerLoaded(request.data));
  } catch (err) {}
}

function searchChild(offers, selectedChild) {
  return offers.filter(
    item =>
      parseInt(item.deposit) === parseInt(selectedChild.deposit) &&
      parseInt(item.distance) === parseInt(selectedChild.distance) &&
      parseInt(item.duration) === parseInt(selectedChild.duration) &&
      (!item.bundle || (item.bundle === selectedChild.bundle))
  )[0];
}

function* actionWatcher() {
  yield takeLatest(GET_OFFER, fetchOffer);
}

export default function* offersData() {
  yield all([actionWatcher()]);
}
